module.exports = "/_next/static/images/ChadRicher-59e092b3593997534fb2aca885420af4.webp";